var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"phone"},[_c('van-field',{attrs:{"type":"tel","label":"新手机号","placeholder":"输入新手机号"},on:{"input":_vm.changePhone},model:{value:(_vm.tel),callback:function ($$v) {_vm.tel=$$v},expression:"tel"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }